import { render, staticRenderFns } from "./cusname-select.vue?vue&type=template&id=2707b671&"
import script from "./cusname-select.vue?vue&type=script&lang=js&"
export * from "./cusname-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports